import { FluxoType } from "../stores/tenant/tenant.types";
import { useTenantStore } from "../stores/tenant/use-tenant-store";

export const isAuthenticated = () => {
  const { type } = useTenantStore.getState();

  if (type === FluxoType.CONSULTOR) return !!sessionStorage.getItem("contactEmail");

  return !!sessionStorage.getItem("token");
};

export const getCaptchaSiteKey = () => process.env.REACT_APP_CAPTCHA_SITE_KEY ?? "";
